
export const accommodationMapping = {
  'camping': ['camping', 'kamperen', 'tent', 'caravan', 'stacaravan'],
  'hotel': ['hotel', 'resort', 'accommodatie'],
  'appartement': ['appartement', 'studio', 'flat', 'vakantiewoning'],
  'villa': ['villa', 'vakantievilla', 'vakantiewoning'],
  'bungalow': ['bungalow', 'chalet', 'lodge'],
  'hostel': ['hostel', 'jeugdherberg', 'backpacker'],
  'pension': ['pension', 'guesthouse', 'bed and breakfast', 'b&b'],
  'cruise': ['cruise', 'cruiseschip', 'boot', 'schip']
};

export const detectAccommodationType = (searchTerms: string[]): string | null => {
  for (const [type, keywords] of Object.entries(accommodationMapping)) {
    if (keywords.some(keyword => searchTerms.includes(keyword))) {
      console.log('Detected accommodation type:', type);
      return type;
    }
  }
  return null;
};
